import { captureException } from '@sentry/react';
import { logOnboardingPatient } from '@api';
import { useApplicationStore } from '@data';
import { LeadData } from '@qmd-types/onboarding';

type Params = Partial<LeadData>;

export default async function logLead(params?: Params): Promise<void> {
  const { getLeadData } = useApplicationStore.getState();

  const leadData = getLeadData();

  if (!leadData?.sessionId) {
    return;
  }

  try {
    await logOnboardingPatient({ ...leadData, ...params });
  } catch (error) {
    captureException(error);
  }
}
